import { Translatable } from "@icc/shared/helpers";

export class RollerBoxSideCap {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do wydruków */
    printCode?: string;
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}

export interface IccRollerBoxSideCap {
    id: number;
    extId: string;
    indexNo: string;
    name: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Powiązane typy produktów */
    shutterTypesIds: number[];
    /** Powiązane profile skrzynek */
    profilesIds: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
